// removed by extract-text-webpack-plugin
module.exports = {"container":"OUMlXpi6FBtLWOyRNQVr6","slider":"_1Dt7nn745xJDPfknHUWOyd","pic":"ISEsTdi7hkjAw-L_g0juG","imageContainer":"_14fDwoHWQbIbxHBZklBZeo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageSlider/ImageSlider.scss
 ** module id = 731
 ** module chunks = 0
 **/